import { Report63Component } from "../../../components/SupportSystem/Reports/Report63Component";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report63Container() {
    const titleName = "ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2) ที่เป็นข้องหน่วยงานรัฐ";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report63Component/>
            <Footer />
        </div>   
        // 
    )
    
}